// IE 2026 11 02 / ODOO-349799 (shortcut-title): окно, открытое ярлыком (экземпляр _multiply, кнопка «Compare & merge…»), держит заголовок строки-источника:
// updateDoc обычных ответов (select / reload …) его не трогает (бэк возвращает там заголовок записи). Но на СВОЁ действие окна (exchange_toggle /
// exchange_swap — смена источника / приёмника) бэк присылает явный title («Compare & merge: This database → File») — он обновляет и _multiply.title,
// и заголовок окна. Флаг fe.ux.shortcutTitle (по умолчанию ВКЛ): выключен — как раньше, заголовок ярлыка не меняется. Тест: tests/unit/shortcutTitle.test.mjs
// IE 2026 11 03 / ODOO-349799 (updateDoc title for multiply window): окно ЯРЛЫКА — это _multiply без ключа тиража (widget_open команды бэка даёт
// multiply_key + _multiply: {title}; тираж widgets_multiply даёт key / ikey). Обычные ответы формы записи / задачи явного title не несут (бэк: title —
// только у exchange_toggle / swap / next / back / refresh, всегда title_of окна), поэтому окно ярлыка принимает ЛЮБОЙ явный title ответа, а не только
// по белому списку методов (next / back / refresh в него не входили — заголовок после них не менялся). Экземпляр тиража (key) — как прежде: только
// ответ своего действия (_ownTitle). Тест: tests/unit/updateDocMultiplyTitle.test.mjs
export const SHORTCUT_TITLE_FLAG = 'fe.ux.shortcutTitle'
const OWN_TITLE_METHODS = /^exchange_(toggle|swap)$/

export function shortcutTitle_on(setting) {
    try { return typeof setting !== 'function' || setting(SHORTCUT_TITLE_FLAG, true) !== false } catch (e) { return true }
}

// метод запроса — своё действие окна, чей ответ несёт явный заголовок
export function shortcutTitle_ownMethod(method) {
    return OWN_TITLE_METHODS.test(String(method || ''))
}

// окно, открытое ярлыком: _multiply с заголовком, но без ключа экземпляра тиража (key / ikey ставит widgets_multiply)
export function shortcutTitle_isShortcut(WIDGET) {   // IE 2026 11 03 / ODOO-349799 (updateDoc title for multiply window)
    const m = WIDGET?._multiply   // IE 2026 11 03 / ODOO-349799 (updateDoc title for multiply window)
    return !!(m && typeof m === 'object' && m.title && !m.key && !m.ikey)   // IE 2026 11 03 / ODOO-349799 (updateDoc title for multiply window)
}

// true — заголовок из ответа принят: _multiply.title обновлён (updateDoc после этого присвоит его WIDGET.title)
export function shortcutTitle_take(WIDGET, action, setting) {
    try {
        if (!WIDGET?._multiply?.title || !shortcutTitle_on(setting)) return false   // IE 2026 11 03 / ODOO-349799 (updateDoc title for multiply window)
        if (!action?._ownTitle && !shortcutTitle_isShortcut(WIDGET)) return false   // IE 2026 11 03 / ODOO-349799 (updateDoc title for multiply window): тираж — только своё действие; ярлык — любой явный title
        if (typeof action.title !== 'string' || !action.title.trim()) return false
        WIDGET._multiply.title = action.title
        return true
    } catch (e) { return false }
}
